import { Inject, Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { RelayNotificationPreferencesMasterObject } from '../models/relay-notifications-models';
import { IdNamePair } from '../models/id-name-pair';
import { InstanceTypes } from '../models/instance-types';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RelayNotificationsService {
  constructor(
    private http: HttpClient,
    @Inject('env') private env: any,
    private authService: AuthService
  ) {}

  public getPreferences() {
    const userId = this.authService.getCurrentUserId();
    const isEmployeeUser = this.env.instanceType === InstanceTypes.EmployeePortal;
    let params = new HttpParams();
    params = params.set('userId', userId.trim());
    params = params.set('isEmployeeUser', isEmployeeUser);
    return this.http.get<RelayNotificationPreferencesMasterObject>(
      `${this.env.apiUrlRoot}/Users/${userId}/Preferences/Notifications`,
      { params }
    );
  }

  public savePreferences(masterObject: RelayNotificationPreferencesMasterObject) {
    const userId = this.authService.getCurrentUserId();
    return this.http.put(
      `${this.env.apiUrlRoot}/Users/${userId}/Preferences/Notifications`,
      masterObject
    );
  }

  public getRequiredNotificationMetadata() {
    return this.http.get<IdNamePair[]>(
      `${this.env.apiUrlRoot}/RelayNotifications/Required/Metadata`
    );
  }

  public sendTestNotification(id: number, name: string, email: string) {
    return this.http.post(`${this.env.apiUrlRoot}/RelayNotifications/${id}/Test`, {
      NotificationName: name,
      RecipientEmail: email
    });
  }

  public sendNotification(
    name: string,
    substitutionData: Map<string, string>,
    clientCode?: string,
    recipients?: string[]
  ) {
    const convMap = {};
    substitutionData.forEach((val: string, key: string) => {
      convMap[key] = val;
    });
    return this.http.post(`${this.env.apiUrlRoot}/RelayNotifications`, {
      NotificationName: name,
      SubstitutionData: convMap,
      ClientCode: clientCode,
      Recipients: recipients
    });
  }
}
